export default __webpack_public_path__ + "static/media/okay.eb32edac.svg";